import { Langs, AlternateHrefLang, AlternateSite, AlternateLocaleUrl } from './config';

const genHref = (url, lang) => `https://www.${
    AlternateSite[lang] || AlternateSite.default
  }/${AlternateLocaleUrl[lang] || lang}${url}`;

export const genAlternates = (url: string, locale: string) => {
  return {
    canonical: genHref(url, locale),
    languages: Langs.reduce((pre, lang) => {
        const hrefLang= AlternateHrefLang[lang] || lang;
        pre[hrefLang] = genHref(url, lang);
        return pre;
    }, {}),
  }
};